package music.jammers.client.shared.analytics.auth

import music.jammers.client.shared.analytics.FirebaseAnalytics
import music.jammers.shared.user.domain.model.User

interface AuthAnalytics {

    fun onGoogleClicked()
    fun onError(throwable: Throwable)
    fun onGoogleAuthSuccess()
    fun onAuthSuccess(user: User?)
}

internal class AuthAnalyticsImpl(
    private val firebaseAnalytics: FirebaseAnalytics,
) : AuthAnalytics {

    override fun onGoogleClicked() {
        firebaseAnalytics.logEvent("auth_google_clicked")
    }

    override fun onError(throwable: Throwable) {
        firebaseAnalytics.logEvent("auth_error") {
            val value = throwable.message ?: throwable.toString()
            param("reason", value.take(VALUE_LIMIT))
        }
    }

    override fun onGoogleAuthSuccess() {
        firebaseAnalytics.logEvent("auth_google_success")
    }

    override fun onAuthSuccess(user: User?) {
        if (user == null) {
            firebaseAnalytics.logEvent("auth_user_error")
        } else {
            firebaseAnalytics.setUserId(user.id.toString())
            firebaseAnalytics.setUserProperty("user_type", user.type.toString().lowercase())
            firebaseAnalytics.logEvent(FirebaseAnalytics.Event.LOGIN)
        }
    }

    private companion object {

        const val VALUE_LIMIT = 40
    }
}